<template>
    <div class="c-tooltip" :class="computedClass" :style="{top: top+'px',  left: left+'px', 'max-width':maxWidth+'px', right: right+'px' }">
        <div class="c-tooltip__wrap" :style="{'max-width':maxWidth+'px'}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
const positions = ["left-bottom", "right-bottom", "left", "right"];

export default {
  name: "cTooltip",
  props: {
    position: {
      required: true,
      validator: function(value) {
        return positions.indexOf(value) > -1;
      }
    },
    top: {
      default: 0
    },
    left: {
      default: null
    },
    right: {
      default: null
    },
    maxWidth: {
        default: null
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    computedClass() {
      return {
        "c-tooltip--bottom-left": this.position === positions[0],
        "c-tooltip--bottom-right": this.position === positions[1],
        "c-tooltip--left": this.position === positions[2],
        "c-tooltip--right": this.position === positions[3]
      };
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.c-tooltip {
  position: absolute;
  z-index: 25;
  $blockname: &;
  width: 100%;
  &__wrap {
    width: 100%;
    background: $tooltip_background;
    position: relative;
    padding: 10px 15px;
    text-align: left;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    font-size: 14px;
    font-family: $RobotoRegular;
    color: #333333;
    p,
    li {
      font-size: 14px;
      font-family: $RobotoRegular;
      color: #333333;
    }
  }

  &--bottom-left {
    #{$blockname}__wrap {
      &:before {
        border: 7px solid transparent;
        border-bottom: 7px solid $tooltip_background;
        border-left: 7px solid $tooltip_background;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        transform: translateY(-100%);
      }
    }
  }
  &--bottom-right {
    #{$blockname}__wrap {
      &:before {
        border: 7px solid transparent;
        border-bottom: 7px solid $tooltip_background;
        border-right: 7px solid $tooltip_background;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        transform: translateY(-100%);
      }
    }
  }
  &--left {
    max-width: 170px;
    #{$blockname}__wrap {
      max-width: 160px;
      p,
      li {
        font-size: 12px;
      }
      &:before {
        border: 7px solid transparent;
        border-top: 7px solid $tooltip_background;
        border-left: 7px solid $tooltip_background;
        content: "";
        position: absolute;
        right: -14px;
        top: 0;
      }
    }
  }
  &--right {
    max-width: 170px;
    #{$blockname}__wrap {
      max-width: 170px;
      p,
      li {
        font-size: 12px;
      }
      &:before {
        border: 7px solid transparent;
        border-top: 7px solid $tooltip_background;
        border-right: 7px solid $tooltip_background;
        content: "";
        position: absolute;
        left: -14px;
        top: 0;
      }
    }
  }
}

    @media screen and (max-width: 700px){
        .c-tooltip ,
        .c-tooltip--left ,
        .c-tooltip--right ,
        .c-tooltip--bottom-right ,
        .c-tooltip--bottom-left {
            .c-tooltip__wrap {
                width: 100%;
                font-size: 12px;
                p,
                li {
                    font-size: 12px;
                    font-family: $RobotoRegular;
                    color: #333333;
                }
            }
        }
    }
</style>
